<template>
  <div class="social-links clearfix">
    <a
        href="https://www.facebook.com/The-Rent-Roll-Broker-295014647236745/?ref=tn_tnmn"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Follow us on Facebook"
        class="social-icon text-white"
    >
      <i class="fa fa-facebook"></i>
    </a>

    <a
        href="https://www.linkedin.com/company/the-rent-roll-broker"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Connect with us on LinkedIn"
        class="social-icon text-white"
    >
      <i class="fa fa-linkedin"></i>
    </a>

    <a
        href="https://www.youtube.com/user/TheRentRollBroker1?feature=mhee"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Watch our videos on YouTube"
        class="social-icon text-white"
    >
      <i class="fa fa-youtube"></i>
    </a>
  </div>
</template>

<script>

</script>
<style>
.social-links i{
  width: 28px;
  height: 28px;
  font-size: 28px;
  margin-left: 10px;
  margin-right: 10px;
}
</style>